<smrts-page [tabTitle]="title">

  <div header class="header inline-element">
    <h1 class="primary-color page-title">{{title}}</h1>

    <div class="inline-element right-header">
      <button mat-icon-button matTooltip="Voltar" class="accent-color" (click)="voltarClick()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
      <button class="btn-salvar-e-novo" mat-raised-button [disableNoPermission]="permissaoEditarLancamento" (click)="salvarENovoClick()">Salvar e criar novo</button>
      <button class="btn-salvar" mat-raised-button [disableNoPermission]="permissaoEditarLancamento" (click)="salvarClick()">Salvar</button>
    </div>
  </div>

  <div class="content">
    <app-cadastro-lote [tiposLancamento]="tiposLancamento" (loteEncontrado)="onLoteEncontrado()"></app-cadastro-lote>
  </div>

</smrts-page>
